import GA4Handler from '../../common/scripts/ga4_support/GA4Handler'
import { shuffle } from '../../common/scripts/utilities'
import { refreshVisibleAds } from '../../common/scripts/utilities/ad_behaviors'
import words_En from './words_En'
import ga4RevealWidgetClickHandler from '../../common/scripts/ga4_support/blocks/reveal_widget'
import words_es from './words_es'

const CONTENT_ITEMS = {
  en: words_En,
  es: words_es
}

const language = document.documentElement.lang

const isMomentTheme = document.documentElement.getAttribute('data-mp-app-theme') === 'moment'

let content = CONTENT_ITEMS[language]
if (!content) {
  content = CONTENT_ITEMS['en']
}

let displayCount = 0
let unseenContent = shuffle(content)

const showBlock = array => {
  array.forEach(block => {
    const { el, disappearClass, appearClass } = block

    el.setAttribute('tabindex', '0')

    el.removeAttribute('aria-hidden')

    el.classList.remove(disappearClass)

    el.classList.add(appearClass)
  })
}

const hideBlock = array => {
  array.forEach(block => {
    const { el, disappearClass, appearClass } = block

    el.setAttribute('tabindex', '-1')
    el.setAttribute('aria-hidden', 'true')

    el.classList.remove(appearClass)
    el.classList.add(disappearClass)
  })
}

const initWordOfDay = () => {
  const widgetContainerSelector = '.block--reveal-widget__word-of-day'
  const widgetContainers = Array.from(document.querySelectorAll(widgetContainerSelector))

  if (!widgetContainers.length) {
    return
  }

  widgetContainers.forEach(widgetContainer => {
    let updatedSlides
    let isRevealed = false

    let isClickedOnce = false
    let isDragging = false,
      startPos = 0,
      currentTranslate = 0,
      prevTranslate = 0,
      animationID = 0,
      currentIndex = 0

    GA4Handler.impressionHandleEvent(widgetContainer as HTMLElement)

    const largeWord = widgetContainer.querySelector('.block-item-word') as HTMLElement
    const phoneticWord = widgetContainer.querySelector('.block-item-word-phonetic') as HTMLElement
    const revealButton = widgetContainer.querySelector(
      '.block-item-word-reveal-button'
    ) as HTMLElement
    const footer = widgetContainer.querySelector('.block-widget-reveal__footer') as HTMLElement
    const definitionsContainer = widgetContainer.querySelector(
      '.block-item-word-definitions'
    ) as HTMLElement
    const reloadIcon = widgetContainer.querySelector('.icon--reload')
    const definitionPagination = widgetContainer.querySelector(
      '.block-item-word-definition-pagination'
    ) as HTMLElement
    widgetContainer.setAttribute('data-gtm-share-text', 'word not revealed')

    const wordDisplay = [
      {
        el: largeWord,
        disappearClass: 'small',
        appearClass: 'large'
      },
      {
        el: phoneticWord,
        disappearClass: 'small',
        appearClass: 'large'
      },
      {
        el: revealButton,
        disappearClass: 'hideElement',
        appearClass: 'showElement'
      }
    ]

    const definitionDisplay = [
      {
        el: definitionsContainer,
        disappearClass: 'hideElement',
        appearClass: 'showElement'
      },
      {
        el: definitionPagination,
        disappearClass: 'hideElement',
        appearClass: 'showElement'
      },
      {
        el: footer,
        disappearClass: 'footerDisappear',
        appearClass: 'footerAppear'
      }
    ]

    if (isMomentTheme) {
      const momentDisplay = [
        {
          el: definitionsContainer,
          disappearClass: 'hideElement',
          appearClass: 'showMoment'
        },
        {
          el: definitionPagination,
          disappearClass: 'hideElement',
          appearClass: 'showMoment'
        }
      ]
      hideBlock(wordDisplay)

      showBlock(momentDisplay)
    }

    const showMessage = () => {
      hideBlock(wordDisplay)
      showBlock(definitionDisplay)
      widgetContainer.setAttribute('data-gtm-feature', 'refresh')

      ga4RevealWidgetClickHandler(
        widgetContainer,
        'editorial',
        'show',
        activeWord.word,
        activeWord.definition[0],
        ++displayCount
      )

      const paginationContainer = document.querySelector(
        '.block-item-word-definition-pagination'
      ) as HTMLElement

      const paginationBarArr = Array.from(
        paginationContainer.querySelectorAll(`[data-mp-word-definition-key]`)
      )

      const filteredBar = paginationBarArr[`${currentIndex}`]

      filteredBar.classList.remove('active')

      if (filteredBar.getAttribute(`data-mp-word-definition-key`) === currentIndex.toString()) {
        filteredBar.classList.remove('inactive')
        return
      }
    }

    const hideMessage = () => {
      hideBlock(definitionDisplay)
      showBlock(wordDisplay)
      widgetContainer.setAttribute('data-gtm-share-text', 'word not revealed')
      widgetContainer.setAttribute('data-gtm-share-advice-text', 'word not revealed')
      widgetContainer.setAttribute('data-gtm-feature', 'show')
    }

    const touchStart = (index: number) => {
      return function (event) {
        currentIndex = index
        startPos = getPositionX(event)
        isDragging = true

        animationID = requestAnimationFrame(animation)
        definitionsContainer.classList.add('grabbing')
      }
    }

    const touchEnd = () => {
      cancelAnimationFrame(animationID)
      isDragging = false

      const movedby = currentTranslate - prevTranslate

      const prevIndex = currentIndex

      if (movedby < -100 && currentIndex < updatedSlides.length - 1) {
        currentIndex += 1
      }

      if (movedby > 100 && currentIndex > 0) {
        currentIndex -= 1
      }
      setPositionByIndex()

      definitionsContainer.classList.remove('grabbing')

      const paginationContainer = document.querySelector(
        '.block-item-word-definition-pagination'
      ) as HTMLElement

      const paginationBarArr = Array.from(
        paginationContainer.querySelectorAll(`[data-mp-word-definition-key]`)
      )

      const currentBar = paginationBarArr[`${currentIndex}`]
      const prevBar = paginationBarArr[`${prevIndex}`]

      prevBar.classList.add('inactive')
      currentBar.classList.remove('inactive')
    }

    const touchMove = event => {
      if (isDragging) {
        const currentPosition = getPositionX(event)

        currentTranslate = prevTranslate + currentPosition - startPos
      }
    }

    const addSlideEvents = (slides: any) => {
      slides.forEach((slide, index) => {
        // Touch Events
        slide.addEventListener('touchstart', touchStart(index), { passive: true })
        slide.addEventListener('touchend', touchEnd, { passive: true })
        slide.addEventListener('touchmove', touchMove, { passive: true })

        // Mouse Events
        slide.addEventListener('mousedown', touchStart(index), { passive: true })
        slide.addEventListener('mouseup', touchEnd, { passive: true })
        slide.addEventListener('mouseleave', touchEnd, { passive: true })
        slide.addEventListener('mousemove', touchMove, { passive: true })
      })
    }

    const setClassList = (punchLineLength: any, memePunchlineContainer: any) => {
      if (punchLineLength > 1 && punchLineLength <= 8) {
        memePunchlineContainer.classList.add('max-character__8')
        memePunchlineContainer.classList.remove('max-character__12')
        memePunchlineContainer.classList.remove('max-character__16')
        memePunchlineContainer.classList.remove('max-character__unset')
        return
      } else if (punchLineLength >= 9 && punchLineLength <= 12) {
        memePunchlineContainer.classList.add('max-character__12')
        memePunchlineContainer.classList.remove('max-character__8')
        memePunchlineContainer.classList.remove('max-character__16')
        memePunchlineContainer.classList.remove('max-character__unset')
        return
      } else if (punchLineLength >= 13 && punchLineLength <= 16) {
        memePunchlineContainer.classList.add('max-character__16')
        memePunchlineContainer.classList.remove('max-character__8')
        memePunchlineContainer.classList.remove('max-character__12')
        memePunchlineContainer.classList.remove('max-character__unset')
        return
      } else if (punchLineLength >= 17) {
        memePunchlineContainer.classList.add('max-character__unset')
        memePunchlineContainer.classList.remove('max-character__8')
        memePunchlineContainer.classList.remove('max-character__12')
        memePunchlineContainer.classList.remove('max-character__16')
        return
      } else {
        memePunchlineContainer.classList.remove('max-character__8')
        memePunchlineContainer.classList.remove('max-character__12')
        memePunchlineContainer.classList.remove('max-character__16')
        memePunchlineContainer.classList.remove('max-character__unset')
      }
    }

    const updateWord = (wordObj: any) => {
      const { word, pronunciation, definition, type, context } = wordObj

      widgetContainer.setAttribute('data-gtm-event-label', word)
      widgetContainer.setAttribute('data-gtm-share-words-text', `${word} - ${definition} `)
      widgetContainer.setAttribute('data-mp-share-words-text', `${word} - ${definition} `)

      setClassList(word.length, largeWord)
      largeWord.innerHTML = word
      phoneticWord.innerHTML = isMomentTheme ? `${type} | ${pronunciation}` : pronunciation

      let stringNumber

      if (!definition[0]) {
        console.log(
          `Word of Day defintion array requires at least 1 entry. Entries found: ${definition.length}`
        )
      }

      // wordOfDayBlock.setAttribute('data-mp-word-definition-length', `${mainContainer.offsetWidth}`)

      definition.forEach((definitionText: string, key: number) => {
        stringNumber = key + 1

        //definition template
        const definitionTemplate = document.createElement('div')
        definitionTemplate.classList.add('block-item-word-definition')
        definitionTemplate.setAttribute('data-mp-reveal-word', `${word}`)
        definitionTemplate.setAttribute('data-mp-word-definition-key', `${key}`)

        // set the width of a definition to the offsetwidth
        // definitionTemplate.style.width = `${mainContainer.offsetWidth}px`

        //definitionDetails template
        const definitionDetailsTemplate = document.createElement('div')
        definitionDetailsTemplate.classList.add('block-item-word-definition-details')

        //definition bar template
        const definitionBar = document.createElement('div')
        definitionBar.classList.add('block-item-word-definition-bar')
        definitionBar.classList.add('inactive')
        definitionBar.setAttribute('data-mp-word-definition-key', `${key}`)

        //definition text template
        const definitionSpan = document.createElement('span')

        //definition context template
        const definitionContext = document.createElement('div')
        definitionContext.classList.add('block-item-word-definition-context')

        //definition count template
        const definitionCount = document.createElement('div')
        definitionCount.classList.add('block-item-word-definition-count')

        //defintion pagination template
        const definitionPaginationTemplate = document.createElement('div')
        definitionPaginationTemplate.classList.add('block-item-word-definition-pagination')

        //set definition textContent
        definitionSpan.textContent = definitionText

        //set definition context
        if (isMomentTheme) {
          definitionContext.innerHTML = `"${`${context}`}"`
        }
        //set definitionCount
        definitionCount.innerHTML = isMomentTheme ? `In context: ` : `${stringNumber.toString()}.`
        definitionDetailsTemplate.appendChild(definitionSpan)
        if (definition.length === 1) definitionBar.classList.add('one')
        if (definition.length === 2) definitionBar.classList.add('two')
        if (definition.length === 3) definitionBar.classList.add('three')
        definitionPagination.appendChild(definitionBar)

        //append the pieces to the single definition
        definitionTemplate.appendChild(definitionContext)
        definitionTemplate.appendChild(definitionCount)
        definitionTemplate.appendChild(definitionDetailsTemplate)

        //append the definition to the DOM
        definitionsContainer.appendChild(definitionTemplate)
      })

      updatedSlides = Array.from(document.querySelectorAll(`[data-mp-reveal-word="${word}"]`))

      addSlideEvents(updatedSlides)
    }

    const refreshWord = (word: object) => {
      definitionsContainer.innerHTML = ''
      definitionPagination.innerHTML = ''
      updateWord(word)
      ga4RevealWidgetClickHandler(widgetContainer, 'editorial', 'refresh', '', '')
    }

    const returnStopPropogation = () => {
      window.oncontextmenu = event => {
        if (event['srcElement'].classList[0].includes('word')) {
          event.preventDefault()
          event.stopPropagation()
          event.stopImmediatePropagation()
          return false
        }
        return true
      }
    }

    const activeWord = unseenContent[0]
    updateWord(activeWord)
    addSlideEvents(updatedSlides)

    const setPositionByIndex = () => {
      currentTranslate = currentIndex * -definitionsContainer.offsetWidth
      prevTranslate = currentTranslate
      setSliderPosition()
    }

    const animation = () => {
      setSliderPosition()
      if (isDragging) requestAnimationFrame(animation)
    }

    const refreshContent = () => {
      if (!isClickedOnce) {
        widgetContainer.removeAttribute('aria-label')
        widgetContainer.setAttribute('aria-labelledby', 'word-of-day__dialog-region')
        isClickedOnce = true
      }

      currentIndex = 0

      returnStopPropogation()

      setSliderPosition(true)

      const freshWord = unseenContent.pop()

      addSlideEvents(updatedSlides)

      if (isClickedOnce && isRevealed) {
        if (!unseenContent.length) {
          unseenContent = shuffle(CONTENT_ITEMS[language])
        }
        hideMessage()
        refreshWord(freshWord)
      }

      if (!isRevealed) {
        if (!unseenContent.length) {
          unseenContent = shuffle(CONTENT_ITEMS[language])
        }

        hideMessage()
        refreshWord(freshWord)
        refreshVisibleAds()
      }
      isRevealed = !isRevealed
      cancelAnimationFrame(animationID)
    }

    const engageContent = () => {
      if (!isClickedOnce) {
        widgetContainer.removeAttribute('aria-label')
        widgetContainer.setAttribute('aria-labelledby', 'word-of-day__dialog-region')
        isClickedOnce = true
      }

      if (isClickedOnce && isRevealed) {
        if (!unseenContent.length) {
          unseenContent = shuffle(CONTENT_ITEMS[language])
        }
        showMessage()
        isRevealed = !isRevealed
      }

      if (!isRevealed) {
        showMessage()
      } else {
        hideMessage()
      }
      isRevealed = !isRevealed
    }

    const getPositionX = event => {
      return event.type.includes('mouse') ? event.pageX : event.touches[0].clientX
    }

    const setSliderPosition = (reset?: boolean) => {
      if (reset) {
        definitionsContainer.style.transform = `translateX(${-0}px)`
        return null
      }

      const widthOfSlide = (-1 * definitionsContainer.offsetWidth) / updatedSlides.length

      definitionsContainer.style.transform = `translateX(${widthOfSlide * currentIndex}px)`
    }

    returnStopPropogation()

    revealButton.addEventListener('click', engageContent)
    revealButton.addEventListener('keyup', (e: any) => {
      if (e.type !== 'keyup') {
        return
      }
      if (['Enter', ' '].includes((e as any).key)) {
        engageContent()
      }
    })

    reloadIcon.addEventListener('click', refreshContent)
    reloadIcon.addEventListener('keyup', (e: any) => {
      if (e.type !== 'keyup') {
        return
      }
      if (['Enter', ' '].includes((e as any).key)) {
        refreshContent()
      }
    })
  })
}

export default initWordOfDay
